module.exports = __webpack_public_path__ + "9953630a73893dfbe8d9f3b9dbceceb1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/swedish_stockings.png
// module id = 216
// module chunks = 0